<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" sm="5" md="4">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" sm="5" md="4">
              <div class="text-right align-end justify-end d-flex">
                <v-text-field
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  v-model="search"
                  style="max-width: 600px"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div>
          <v-data-table
            :headers="headers"
            :items="datatableItems"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
            :footer-props="{
              'items-per-page-text': $t('rowsPerPage'),
            }"
          >
            <template v-slot:item.deposit_id="{ item }">
              <v-btn @click="$copy(item.deposit_id)" x-small>
                {{ item.deposit_id }}
              </v-btn>
            </template>
            <template v-slot:item.id_player="{ item }">
              <v-btn @click="$copy(item.id_player)" x-small>
                {{ item.id_player }}
              </v-btn>
            </template>

            <template v-slot:item.value_consolidated="{ item }">
              <span :class="getColor(item.value_consolidated)">
                {{ item.value_consolidated }}
              </span>
            </template>

            <template v-slot:item.ip="{ item }">
              <span v-if="item.ip">{{ item.ip }}</span>
              <v-icon v-else>mdi-dots-horizontal</v-icon>
            </template>

            <template v-slot:item.status="{ item }">
              <div v-html="item.status"></div>
            </template>
          </v-data-table>
        </div>
      </v-card>
      <!-- Resume -->
      <div class="mt-4" v-if="datatableItems != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in resumePeriod"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">{{ TranslateKey(item) }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume[item].value)"
                      >
                        {{ resume[item].value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "view-backoffice-administrator-financialOnline-listDeposits",
  components: {
    HeaderPrint,
  },
  data: () => ({
    resumePeriod: [],
    valueColors: ["value_entry"],
    // Datatable
    search: "",

    datatableItems: [],

    // body request
    date_start: "",
    date_final: "",
    status: "",
    headers: [],
  }),
  mounted() {
    this.headers = [
      {
        text: this.$t("depositID"),
        value: "deposit_id",
        sortable: false,
      },
      {
        text: this.$t("value"),
        value: "value_consolidated",
      },
      {
        text: this.$t("dateHour"),
        value: "deposit_date",
        sortable: true,
      },
      {
        text: this.$t("paymentProvider"),
        value: "gateway_name",
      },
      {
        text: this.$t("idUser"),
        value: "id_player",
        sortable: false,
      },
      {
        text: this.$t("user"),
        value: "name_player",
        sortable: false,
      },
      {
        text: "IP",
        value: "ip",
      },
      {
        text: this.$t("status"),
        value: "status",
        sortable: false,
      },
    ];
  },
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    statusDeposit() {
      return this.$store.state.filters.selectTypeBankStatement.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    goTo() {
      return this.$store.state.filters.TabsNavigationButtons.route;
    },
    paymentProvider() {
      return this.$store.state.filters.paymentProvider.value;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getData();
    },
    goTo(val) {
      this.$router
        .push({
          name: val,
        })
        .catch(() => {});
    },
  },
  methods: {
    updateIpHeader(hasOneIp) {
      const ipHeaderSet = this.headers.some((item) => item.value === "ip");

      if (ipHeaderSet && !hasOneIp) {
        this.headers = this.headers.filter((item) => item.value !== "ip");
        return;
      }

      if (!ipHeaderSet && hasOneIp) {
        const ipHeader = {
          text: "IP",
          value: "ip",
          sortable: false,
        };

        this.headers = [
          ...this.headers.slice(0, 4),
          ipHeader,
          ...this.headers.slice(4),
        ];
      }
    },
    reset() {
      this.datatableItems = [];
      this.resumePeriod = [];
    },
    async getData() {
      this.reset();
      const body = {
        ...this.rangeDate,
        status: this.statusDeposit,
        payment_provider: this.paymentProvider,
        export: this.exportDoc,
      };

      let response;
      
      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/administrator/bankOnline/listDeposits",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/administrator/bankOnline/listDeposits",
          body
        );
      }
      if (!response.dados) return;
      
      try {
        const hasOneIp = response.dados.some(
          (item) => item.ip && item.ip != ""
        );
  
        this.updateIpHeader(hasOneIp);
  
        this.datatableItems = response.dados;
        this.datatableItems.forEach((item) => {
          item.deposit_date = new Date(
            item.deposit_date.replace(" ", "T")
          ).toLocaleString();
          item.status = this.statusOperationUI(item.status);
        });
        this.buildResumeData(this.datatableItems);
      } catch (error) {
        console.log(error)
      }
      // this.$request
      //   .post("/administrator/bankOnline/listDeposits", body)
      //   .then((response) => {
      //     if (!response.dados) return;

      //     const hasOneIp = response.dados.some(
      //       (item) => item.ip && item.ip != ""
      //     );

      //     this.updateIpHeader(hasOneIp);

      //     this.datatableItems = response.dados;
      //     this.datatableItems.forEach((item) => {
      //       item.deposit_date = new Date(
      //         item.deposit_date.replace(" ", "T")
      //       ).toLocaleString();
      //       item.status = this.statusOperationUI(item.status);
      //     });
      //     this.buildResumeData(this.datatableItems);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    buildResumeData(datatableItems) {
      if (!datatableItems) return;
      // Add
      const sum = (key) => {
        return datatableItems
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      let resume = {
        value_consolidated: {},
      };

      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(total);
      });

      this.resume = { ...resume };
      this.resumePeriod = Object.keys(this.resume);
      this.resumeExcelCopy();
    },

    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `<table>
        <tr>${this.resume.value_consolidated.value
          .toString()
          .replace(".", ",")}</tr>  
     </table>`;
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    // Status for extratc
    statusOperationUI(value) {
      const obj = {
        1: `<span class="my-1 v-chip theme--light v-size--small orange darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "requisted"
        )}</span></span>`,
        3: `<span class="my-1 v-chip theme--light v-size--small green darken  white--text"><span class="v-chip__content">${this.$t(
          "consolidated"
        )}</span></span>`,
        4: `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content">${this.$t(
          "didCancelled"
        )}</span></span>`,
      };
      return obj[value];
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        value_consolidated: this.$t("deposit"),
      };
      return myKeysTranslated[key] || null;
    },
  },
  filters: {},
};
</script>
